// extracted by mini-css-extract-plugin
export default {"container":"TransferPoolList_container__Cgo6k","employeeListContainer":"TransferPoolList_employeeListContainer__UGvaR"};